import type { Key } from '@luvio/service-cache/v1';

// Needs TS 2023+ (esnext) AND node 20+ to remove
export function setOverlaps(setA: Set<Key>, setB: Set<Key>): boolean {
    if (setA.size > setB.size) {
        for (const key of setB.keys()) {
            if (setA.has(key)) {
                return true;
            }
        }
    } else {
        for (const key of setA) {
            if (setB.has(key)) {
                return true;
            }
        }
    }
    return false;
}
